import * as _ from "lodash";
import * as Constants from "../common/constants";
import { createWebServiceDataSource } from "../common/data";
import * as Global from "../common/global";
import * as GridUtil from "../common/gridFilter";
import * as UI from "../common/ui";
import * as TemplateData from "../data/templateData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";
import * as Data from "../interfaces/data";

// classes used to display a list of templates

// parameters for filtering the list
interface ITemplatesListFilter {
    SearchText?: string;
    IncludeActive: boolean;
    IncludeInactive: boolean;
}

export class TemplatesController implements IController {
    // private properties

    // controls
    private grid: kendo.ui.Grid;
    private dataSource: kendo.data.DataSource;
    private gridFilterControl: GridUtil.GridFilterControl;

    // references to DOM elements
    private gridContainer: JQuery;

    // public methods

    // outputs the control to the HTML
    // returns a jQuery promise.
    public render(container: JQuery): JQueryPromise<any> {
        const me: TemplatesController = this;
        const app: IApplication = Global.app();
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        me.gridContainer = container.find("div[data-id='grid']");

        // create the grid
        me.dataSource = new kendo.data.DataSource({
            pageSize: 100,
        });

        // bind to copy form link in the grid
        me.gridContainer.on("click", "a[data-id='copyLink']", function(e: any) {

            const ID: string | undefined = $(this).attr("href");
            e.preventDefault();

            UI.showConfirmDialog("Are you sure you want to copy this template?", () => {
                TemplateData.CopyTemplate(ID)
                .done((response: Data.IResponse<number>) => {
                    if (response.Success) {
                        UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                        me.refresh();
                        deferred.resolve();
                    } else {
                        UI.showErrorMessage(response.ErrorMessages);
                        deferred.reject();
                    }
                })
                .fail(() => {
                    deferred.reject();
                });
            });
        });

        me.grid = me.gridContainer.kendoGrid({
            dataSource: me.dataSource,
            selectable: false,
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                { title: "ID", field: "ID" },
                { title: "Name", field: "TemplateName", template: kendo.template($("#template_templates_templatename").html()) },
                { title: "Target Type", field: "TargetTemplateName" },
                { title: "Copy Template", template: "<a href=\"#: ID #\" title=\"Open Template\" data-id=\"copyLink\">Copy Template</a>" },
                {
                    title: "Last Modified", field: "DateTimeModified",
                    template: kendo.template($("#template_templates_lastmodifieddate").html()),
                },
                { title: "Modified By", field: "ModifedByFullName" },
            ],
            excel: {
                fileName: "Templates.xlsx",
                filterable: true,
                allPages: true,
            },
        }).data("kendoGrid");

        me.grid.hideColumn(0);
        me.gridFilterControl = new GridUtil.GridFilterControl(container.find("div[data-id='filter']"), {
            showTextSearch: true,
            showExportToExcel: true,
            showFilters: true,
            showRefresh: true,
            filters: [
                { name: Constants.PHRASE_FILTER_SHOWACTIVE, checked: true },
                { name: Constants.PHRASE_FILTER_SHOWINACTIVE, checked: false },
            ],
            grid: me.grid,
        });

        // bind to all link tags in the grid
        me.gridContainer.on("click", "a[data-id='link']", function(e: any): boolean {
            const path: string | undefined = $(this).attr("href");
            e.preventDefault();
            // open the page
            app.router().navigate(_.defaultTo<string>(path, ""), true);
            return false;
        });

        deferred.resolve();

        return deferred.promise();
    }

    // put data into this control.
    // call after rendering the control
    public load(params: any[]): JQueryPromise<any> {
        const app: IApplication = Global.app();
        const me: TemplatesController = this;
        let dataSource: kendo.data.DataSource;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        dataSource = createWebServiceDataSource(
            "/api/Templates",
            {
                id: "ID",
                fields: {
                    ID: { type: "long" },
                    TemplateName: { type: "string" },
                    TargetTemplateName: { type: "string" },
                    DateTimeModified: { type: "date" },
                    IsActive: { type: "boolean" },
                    ModifedByFullName: { type: "string" },
                },
            },
            (data: any) => {
                me.setDataFilter(data);
            },
            (status: number) => {
                if (status === Constants.HTTP_STATUS_UNAUTHORIZED) {
                    // user is not allowed to view this data, so close the page
                    app.pageManager().closeCurrentPage();
                }
                // for other errors, keep page open, allow user to retry.
            });

        // load data into the grid by calling a web service
        me.grid.setDataSource(dataSource);

        deferred.resolve();
        return deferred.promise();
    }

    public add(): void {
        Global.app().router().navigate("/Template", true);
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public height(height: number): void {
        if (height > GridUtil.GRIDFILTERCONTROL_HEIGHT) {
            UI.resizeGrid(this.gridContainer, height - GridUtil.GRIDFILTERCONTROL_HEIGHT);
        }
    }

    // called when loaded page is redisplayed
    public refresh(): void {
        this.grid.dataSource.read();
    }

    // returns a unique ID for the control, so it can be redisplayed if
    // already open.  Used by the AppRouter class.
    public appRouterID(params: string[]): string {
        return "Templates";
    }

    // returns a title for the page
    public title(): string {
        return `${Constants.LABEL_APPOINTMENT} Templates`;
    }

    public subTitle(): string {
        return "";
    }

    private setDataFilter(data: ITemplatesListFilter): void {
        data.IncludeActive = true;
        data.IncludeInactive = false;

        if (this.gridFilterControl != null) {
            this.gridFilterControl.setDataFilter(data);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/templates.ts